import { SDK_GLOBAL_NAME, TEA_ANALYTICS_OBJECT, DEFAULT_SDK_SCRIPT_URL } from './constants';
import { isBrowser } from './utils';

/**
 * Load the DataRangers SDK script dynamically.
 * Uses the TeaAnalyticsObject command-queue pattern so that
 * init/start calls made before the script loads are queued
 * and replayed automatically once the script executes.
 */
export function loadSDK(scriptUrl?: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!isBrowser()) {
      resolve();
      return;
    }

    // Step 1: Set up the command queue stub if not already present
    (window as any)[TEA_ANALYTICS_OBJECT] = SDK_GLOBAL_NAME;

    if (!(window as any)[SDK_GLOBAL_NAME]) {
      function _collect(...args: any[]) {
        (_collect as any).q.push(args);
      }
      (_collect as any).q = (_collect as any).q || [];
      (window as any)[SDK_GLOBAL_NAME] = _collect;
    }
    (window as any)[SDK_GLOBAL_NAME].l = Date.now();

    // Step 2: If the script is already loaded, resolve immediately
    const existingScript = document.querySelector(
      `script[src="${scriptUrl || DEFAULT_SDK_SCRIPT_URL}"]`,
    );
    if (existingScript) {
      resolve();
      return;
    }

    // Step 3: Inject the async script
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptUrl || DEFAULT_SDK_SCRIPT_URL;

    script.onload = () => resolve();
    script.onerror = () => {
      console.warn('[yl-nsm-track] Failed to load SDK script');
      // Resolve anyway — queued commands will simply not execute,
      // but the app should not crash
      resolve();
    };

    document.head.appendChild(script);
  });
}
